export default __webpack_public_path__ + "static/media/goshen16.818eb066.jpg";